<div @fadeInAnimation>
  <div class="order-page-title" id="top">
    <eps-button class="edit-button" (buttonClick)="cancelClicked()" label="SHARED.BUTTONS.BACK" *ngIf="panelStatus.backButton.isVisible"></eps-button>
    <div *ngIf="mode.state === 'view'" class="content">
      <app-status *ngIf="mode.state === 'view'" layout="BULLET" key="{{ 'ORDER_' + orderDetail.status }}" height="40" [size]="1"> </app-status>
      <div class="multi-line">
        <div>
          <app-title title="ORDERS.DETAILS.TITLE"></app-title>
          <span class="subtitle">{{ orderDetail.etmOrderNumber }}</span>
        </div>
        <div>
          <span class="bold">{{ 'ORDERS.DETAILS.REGISTERED_BY' | translate }}</span> {{ orderDetail.registeredBy }}
        </div>
      </div>
    </div>
<!--    <app-title *ngIf="mode.state !== 'view'" title="SHARED.BUTTONS.CREATE" subtitle="CCR.DETAILS.TITLE"></app-title>-->
    <app-title *ngIf="isCreate()" title="SHARED.BUTTONS.CREATE" subtitle="CCR.DETAILS.TITLE"></app-title>
    <app-title *ngIf="isEdit()" title="SHARED.BUTTONS.UPDATE" subtitle="CCR.DETAILS.TITLE"></app-title>
  </div>

  <div class="row filter-container">
    <div class="col-12 col-md-12 col-lg-9 filter-container-inner">
      <form [formGroup]="ccrForm">
        <!-- CUSTOMER -->
        <div class="order-create-title-bar" *ngIf="panelStatus.customer.blockIsVisible">
          <div class="row order-create-title-bar-header" [ngClass]="{ activated: panelStatus.customer.isEdit }">
            <div class="order-create-title">
              <i class="fa fa-address-card" aria-hidden="true"></i>
              <b>{{ panelStatus.customer.nr }}&nbsp;&nbsp;{{ 'ORDERS.CUSTOMER.TITLE' | translate }}</b> {{ 'ORDERS.DELIVERY.SUBTITLE' | translate }}
            </div>
          </div>
        </div>
        <app-florder-select-customer
          [panelStatus]="panelStatus.customer"
          [customer]="orderDetail.customer"
          [customers]="customers"
          *ngIf="panelStatus.customer.blockIsVisible"
        ></app-florder-select-customer>

        <div class="order-create-title-bar">
          <div class="order-create-title-bar-header title-action-bar">
            <div class="order-create-title">
              <i class="fa fa-truck" aria-hidden="true"></i>
              <b>{{ panelStatus.delivery.nr }}&nbsp;&nbsp;{{ 'ORDERS.DELIVERY.TITLE' | translate }}</b> {{ 'ORDERS.DELIVERY.SUBTITLE' | translate }}
            </div>
            <div class="edit-button" *ngIf="panelStatus.delivery.isEditable" (click)="editDeliveryMethodClicked()">
              <a mat-raised-button class="default">{{ 'SHARED.BUTTONS.EDIT' | translate }}</a>
            </div>
          </div>
          <app-ccr-edit-delivery
            [ccrForm]="ccrForm"
            [definitions]="definitions"
            [deliveryMethod]="orderDetail.deliveryMethod"
            [orderTypes]="orderTypes"
            [panelStatus]="panelStatus.delivery"
          >
          </app-ccr-edit-delivery>
        </div>

        <div class="order-create-title-bar">
          <div class="order-create-title-bar-header activated title-action-bar">
            <div class="order-create-title">
              <i class="fa fa-file-o" aria-hidden="true"></i>
              <b>{{ panelStatus.detail.nr }}&nbsp;&nbsp;{{ 'CCR.DETAILS.TITLE' | translate }}</b> {{ 'ORDERS.DETAILS.SUBTITLE' | translate }}
            </div>
            <div class="edit-button" *ngIf="panelStatus.detail.isEditable" (click)="editDetailClicked()">
              <a mat-raised-button class="default"> {{ 'SHARED.BUTTONS.EDIT' | translate }} </a>
            </div>
          </div>
        </div>
        <app-ccr-edit-detail
          *ngIf="panelStatus.detail.isVisible"
          [ccrForm]="ccrForm"
          [definitions]="definitions"
          [editMaterial]="mode.material"
          [orderDetail]="orderDetail"
          [orderTypes]="orderTypes"
          [panelStatusMaterial]="panelStatus.material"
          [panelStatus]="panelStatus.detail"
          [materialTypes]="incoterm"
          (cancelClicked)="cancelClicked()"
          (backClicked)="backToDeliveryClicked()"
          (nextClicked)="submitClickedFn()"
          (saveMaterialClicked)="saveMaterial($event)"
          (removeMaterialClicked)="removeMaterial($event)"
          (startEditMaterialClicked)="editMaterial($event)"
        >
        </app-ccr-edit-detail>
        <!-- PLANNING -->
        <div class="order-create-title-bar">
          <div class="order-create-title-bar-header activated title-action-bar">
            <div class="order-create-title">
              <i class="fa fa-calendar-check-o" aria-hidden="true"></i>
              <b>{{ panelStatus.planning.nr }}&nbsp;&nbsp;{{ 'CCR.DETAILS.TITLE' | translate }}</b> {{ 'ORDERS.PLANNING.SUBTITLE' | translate }}
            </div>
            <div class="edit-button" *ngIf="panelStatus.planning.isEditable" (click)="editPlanningClicked()">
              <a mat-raised-button class="default">
                {{ 'SHARED.BUTTONS.EDIT' | translate }}
              </a>
            </div>
          </div>
        </div>
        <app-ccr-edit-planning
          *ngIf="panelStatus.planning.isVisible"
          [ccrForm]="ccrForm"
          [orderDetail]="orderDetail"
          [panelStatus]="panelStatus.planning"
          [availablePickingDates]="getAvailablePickingDates()"
        >
        </app-ccr-edit-planning>
      </form>
    </div>
  </div>

  <div class="col-12 col-md-12 col-lg-9 buttons">
    <eps-button
      type="link"
      *ngIf="panelStatus.ccr.isEdit"
      (buttonClick)="cancelClicked()"
      label="SHARED.BUTTONS.CANCEL"
    ></eps-button>
    <eps-button
      [disabled]="!ccrForm.valid || mode.saving"
      [busy]="mode.saving"
      (buttonClick)="submitClickedFn()"
      label="SHARED.BUTTONS.SUBMIT"
    ></eps-button>

  </div>
</div>
